import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

const fromAnyToInitials = (name) => {
  const array = fromAnyToString(name).match(/\b\w/g) || [];
  return fromAnyToTrimmed(array.shift()) + fromAnyToTrimmed(array.pop());
};

export default fromAnyToInitials;
